module.exports = __webpack_public_path__ + "static/lake_aerial_5-372cdf8b227c8c766cdd2532a11289cf.jpg";